<template>
  <div class="w100 Overview">
    <div class="search-top" v-loading="Loading">
      <div>
        <el-select
          v-model="searchData.supplier"
          filterable
          clearable
          style="width: 260px"
          placeholder="请选择供应商"
        >
          <el-option
            v-for="item in SupplierData"
            :key="item.Id"
            :label="item.title"
            :value="item.title"
          ></el-option>
        </el-select>
        <el-select
          style="width: 260px; margin-left: 10px"
          v-model="searchData.DocType"
          filterable
          clearable
          placeholder="请选择文件类型"
        >
          <el-option
            v-for="item in SupplierQualificationsList"
            :key="item.Id"
            :label="item.DicName"
            :value="item.DicName"
          ></el-option>
        </el-select>
        <el-input
          style="width: 260px; margin-left: 10px"
          placeholder="请输入文件名称"
          v-model="searchData.DocName"
          clearable
        ></el-input>
        <el-button
          type="primary"
          @click="getDataList"
          style="margin-left: 10px"
        >
          查询</el-button
        >
      </div>
    </div>
    <el-table
      class="table-ove"
      :data="Data"
      style="width: 100%"
      header-row-class-name="table-tit"
      :row-class-name="rowName"
      v-loading="Loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="SupplierName"
        label="供应商名称"
        width="360px"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="TypeName"
        label="文件类型"
        width="200px"
        align="center"
      ></el-table-column>
      <el-table-column prop="NewFileName" label="文件名称" align="center">
        <template slot-scope="scope">
          <a :href="scope.row.Url" target="_blank" style="color: #409eff">{{
            scope.row.NewFileName
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="CreateTime" label="上传日期" width="160px">
        <template slot-scope="scope">
          {{ moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      Loading: false,
      Data: [],
      searchData: {
        supplier: '',
        DocType: '',
        DocName: '',
      },
      SupplierQualificationsList: [],
      SupplierData: [],
    }
  },
  props: {
    pId: {
      type: String,
      default: '',
    },
  },
  components: {},
  methods: {
    getSupplierData() {
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'ProjectSupplierTree',
          ProjectId: this.pId,
        })
        .then((res) => {
          if (res.Success) {
            this.SupplierData = res.Data
          }
        })
    },
    getSelectList() {
      // let arr = ['SupplierType', 'SupplierQualifications']

      // arr.forEach((item) => {

      // })
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'TheDataByDicKey',
          Keyword: 'SupplierType',
        })
        .then((res) => {
          if (res.Success)
            this.SupplierQualificationsList =
              res.Data.DictionaryDetailsList || []
        })
    },
    rowName(obj) {
      if (obj.row.Leve == 1) {
        return 'level1'
      }
    },
    getDataList() {
      this.Loading = true
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'FileSupplier',
          ProjectId: this.pId,
          ...this.searchData,
        })
        .then((res) => {
          this.Loading = false
          if (res.Success) {
            this.Data = res.Data || []
          }
        })
    },
  },
  mounted() {
    // this.initCharts()
  },
  created() {
    this.getSupplierData()
    this.getSelectList()
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .table-tit {
  font-weight: 1000;
  font-size: 16px;
  color: #000;
  height: 40px;
}
.table-ove {
  margin-bottom: 20px;
}
.Overview {
  padding: 0 10px;
}
::v-deep .el-table__body-wrapper {
  .el-table__cell {
    font-size: 14px;
  }
}
::v-deep .level1 {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}
</style>
